<template>
    <div class="stocktake-mode">
        <el-select v-model="mode.stocktakeMode" class="stocktake-mode-select" @change="stocktakeModeChange">
            <el-option :value="0" label="全部"></el-option>
            <el-option :value="1" label="指定库区"></el-option>
            <el-option :value="3" label="指定库位"></el-option>
        </el-select>
        <areaSelect
            :poiId="poiId"
            v-if="mode.stocktakeMode === 1"
            :disabled="mode.stocktakeMode === 0"
            filterable
            :clearable="true"
            :setDefault="false"
            class="area-shelf-input"
            v-model="mode.areaOrShelf"
        ></areaSelect>
        <el-input v-model="mode.areaOrShelf" :disabled="mode.stocktakeMode === 0" class="area-shelf-input" clearable v-else></el-input>
    </div>
</template>

<script>
import areaSelect from '../../Select/AreaSelectWws';

export default {
    name: 'XxStocktakeMode',
    props: {
        poiId: {
            type: [String, Number],
            default: ''
        },
        value: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        areaSelect
    },
    data() {
        return {
            mode: {
                stocktakeMode: (this.value && this.value.stocktakeMode) || 0,
                areaOrShelf: ''
            }
        };
    },
    watch: {
        mode: {
            deep: true,
            handler(v) {
                this.$emit('input', v);
            }
        },
        value: {
            deep: true,
            handler(v) {
                this.mode = v;
            }
        }
    },
    methods: {
        stocktakeModeChange(v) {
            this.mode.areaOrShelf = '';
        }
    }
};
</script>

<style lang="scss" scoped>
.stocktake-mode {
    display: inline-block;
    .stocktake-mode-select {
        width: 98px;
    }
    .area-shelf-input {
        width: 120px;
    }
}
</style>
